export class InteropHostCallError extends Error {
  constructor() {
    super('Interop host call failed');
    this.name = 'InteropHostCallError';
  }
}
